const el_instagramTheme = $('.instagram-theme');

if (el_instagramTheme.length) {
    window.$.subscribe('/product/added-to-cart', function (event, product_unique_id, basket_response) {

        const el_basketFrame = $('[name=basket-frame]'),
        el_body = $('body');

        if (el_instagramTheme.hasClass('instagram-basket-type-hidden')) {

            el_basketFrame[0].src = el_basketFrame[0].src; // Reloads iframe.

            el_basketFrame.on('load', function () {

                if (!el_basketFrame.hasClass('visible')) {

                    el_basketFrame.addClass('visible');

                }

                $('html, body').animate({
                    scrollTop: el_basketFrame.offset().top - $('.site-header').height()
                }, 500);

                el_body.removeClass('adding-to-cart');

            });

        } else if (el_instagramTheme.hasClass('instagram-basket-type-page')) {

            if (el_body.hasClass('should-redirect')){

                location.href = $('[data-instastore-basket-button][data-href]').data('href');

            }else{

                el_body.removeClass('adding-to-cart');

            }
        }

    });

    window.$.subscribe('/product/add-to-cart/start', function (event) {
        $('body').addClass('adding-to-cart');
    });

    window.$.subscribe('/product/add-to-cart/error', function (event) {
        $('body').removeClass('adding-to-cart');
    });

    $('[data-instastore-basket-button]').on('click', function (){

        if ($(this).data('href')){
            $('body').addClass('should-redirect');
        }else{
            $('body').removeClass('should-redirect');
        }

        $('#submit-form').trigger('click');

    });

}
